module.exports = __webpack_public_path__ + "static/img/bg-en.dbd9a812.png";